module.exports = __webpack_public_path__ + "img/UTHYRU-6.bb25338a.jpg";